(function () {
  'use strict';

  function initBadge(root) {
    var pillsEl = root.querySelector('[data-plb-pills]');
    var options = document.querySelectorAll('.pls-option[data-location]');
    if (!options.length) return; // print-location-selector not on this page

    var labels = [];
    options.forEach(function (el) {
      var titleEl = el.querySelector('.pls-option-title') ||
        el.querySelector('.pls-promo-locked-text strong');
      if (titleEl && titleEl.textContent.trim()) {
        labels.push(titleEl.textContent.trim());
      }
    });
    if (!labels.length) return;

    pillsEl.innerHTML = '';
    labels.forEach(function (label) {
      var pill = document.createElement('span');
      pill.className = 'ft-plb__pill';
      pill.textContent = label;
      pillsEl.appendChild(pill);
    });
    root.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ft-print-locations-badge]').forEach(initBadge);
  });
})();
